import { createRoot } from 'react-dom/client';
import { App } from './App';
import './index.scss';
import * as serviceWorker from './serviceWorker';

const rootHTMLElement = document.getElementById('root')
if (rootHTMLElement != null)
    createRoot(rootHTMLElement).render(<App />);
else
    console.log("root is not present in document")

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();